import React from "react";
import { DropzoneArea } from "material-ui-dropzone";

const FileDropzoneArea = props => {
    const handleChange = e => {
        props.onFileUpload(e[0]);
    };

    return (
        <div style={{ width: "500px" }}>
            <DropzoneArea
                initialFiles={props.file ? [props.file] : []}
                onChange={e => handleChange(e)}
                acceptedFiles={[".csv"]}
                maxFileSize={10000000} // 10000000 = 10mb
                filesLimit={1}
                dropzoneText="Upload file"
                useChipsForPreview={true}
                dropzoneClass="dropzone"
                showAlerts={false}
            />
        </div>
    );
};

export default FileDropzoneArea;
